import React from "react";
import PropTypes from "prop-types";

/**
 * Komponent pojedyńczej metody płatności
 * 
 * @param {object} paymentMethod metoda płatności
 */
const PaymentMethod = ({ paymentMethod }) => {

    return (
        <div className="w3-bar-item w3-border" style={{ height: '80px', width: '187px' }}>
            <img src={paymentMethod.imgUrl} alt="payment method" style={{ height: '40px', width: '100%' }} />
            <span className="w3-xsmall"><b>{paymentMethod.id}</b> - {paymentMethod.name}</span>
        </div>
    )
}

PaymentMethod.propTypes = {
    paymentMethod: PropTypes.object.isRequired
};

/**
 * Komponent z kolekcja metod płatności
 * 
 * @param {*} paymentMethodList 
 */
const PaymentMethodList = ({ paymentMethodList }) => {
    return (
        <div className="w3-bar w3-small">
            {paymentMethodList.map((item) => <PaymentMethod key={item.id} paymentMethod={item} />)}
        </div>
    )
}

PaymentMethodList.propTypes = {
    paymentMethodList: PropTypes.array.isRequired
};

class P24MerchantPaymentMethods extends React.Component {

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit();
    };

    render() {

        return (
            <div className="w3-card-4" >
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">{this.props.title}</h2>
                </div>

                <div className="w3-padding" style={{ overflowY: 'auto', height: '700px' }}>

                    <PaymentMethodList paymentMethodList={this.props.p24MerchantPaymentMethodList} />

                </div>

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            {this.props.submitText}
                        </button>
                    </div>
                </form>
            </div>
        )
    }

}

P24MerchantPaymentMethods.defaultProps = {
    title: 'Metody płatności',
    submitText: 'Zamknij'
}

P24MerchantPaymentMethods.propTypes = {
    //tytul formularza
    title: PropTypes.string.isRequired,
    //dane wejsciowe obiektu do wypelnienia
    p24MerchantPaymentMethodList: PropTypes.array.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired,
    //tekst na akcji zamknięcie formularza
    submitText: PropTypes.string.isRequired
}

export default P24MerchantPaymentMethods;